
































import { getSmsClients } from '@/api/Sms/sms.api'
import ActionButton from '@/components/ActionButton.vue'
import ClientCrudDialog from '@/components/Services/Sms/ClientCrudDialog.vue'
import { TableHeader } from '@/utils/interfaces'
import { tableHandler } from '@/utils/mixins/tableHandler'
import FlatCard from '~/components/FlatCard.vue'
import FlatTable from '~/components/FlatTable.vue'
import TextButton from '~/components/TextButton.vue'

export default tableHandler().extend({
  components: {
    ActionButton,
    ClientCrudDialog,
    FlatCard,
    FlatTable,
    TextButton,
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('name'),
          value: 'name',
        },
        {
          text: this.$t('tags'),
          value: 'tags_name',
        },
        {
          text: this.$t('phone_number'),
          value: 'phone',
        },
        {
          text: this.$t('actions'),
          value: 'actions',
        },
      ] as TableHeader[],
      getter: getSmsClients,
    }
  },
  methods: {
    onRefresh() {
      this.table.refresh()
    },
  },
})
